export const Constants = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  ENV_NAME: import.meta.env.VITE_ENV_NAME,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  MINIAPP_URL: import.meta.env.VITE_MINIAPP_URL,
} as const
export type Constants = keyof typeof Constants

export const colorPalette: Record<string, Record<string, string>> = {
  service: {
    primary: '#191919',
    lighter: '#8C8C8C',
    secondary: '#E8E8E8',
  },
  bg: {
    base: '#F8F9FA',
    f: '#FFFFFF',
    lighter: '#464646',
    black: '#191919',
  },
  text: {
    base: '#2f2f2f',
    f: '#FFFFFF', // on: bg.primary, name: whiteだと謎に読み込まれないことがあるっぽい
    fPale: 'rgba(255,255,255,0.7)',
    fDisabled: 'rgba(255,255,255,0.38)',
    disabled: '#9E9E9E',
  },
  border: {
    divider: '#EDEFF3', // on: bg.base
    base: '#E8E8E8',
    active: '#B9C1D2',
    fPale: 'rgba(255,255,255,0.25)',
  },
  shadow: {
    base: 'rgba(255,255,255, 0.1)',
    lighter: 'rgba(96,115,153,0.1)',
    card: '0 1px 10px 0 rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.14)',
    bottomSheet:
      '0 1px 10px 0 rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.14)',
  },
  utility: {
    green: '#1C616E', // success, done
    greenLighter: '#31a9bf',
    greenBg: '#E8EFF0',
    yellow: '#D69E70', // caution
    yellowBg: '#F6EBE2',
    red: '#D46F72', // danger, warning, failure
    redBg: '#FAF0F0',
  },
}
